// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { clamp } from './number'

interface ILnglatMap {
  [lnglatKey: string]: boolean
}

type LnglatArray = [number, number]

/**
 * Ensure that all of cameras don't place overlapped
 */
export class LnglatShift {
  _lnglatMap: ILnglatMap = {}
  _offset: number
  _offsetTarget: string = null

  constructor (offset = 0.00001) {
    this._offset = offset
  }

  shift (lng, lat): LnglatArray {
    let shifted
    let offsetLng = lng
    let offsetLat = lat
    let key = this._generateKey(offsetLng, offsetLat)
    while (this._has(key)) {
      shifted = this._randomShift(offsetLng, offsetLat)
      offsetLng = shifted[0]
      offsetLat = shifted[1]
      key = this._generateKey(offsetLng, offsetLat)
    }
    this._add(key)
    return [offsetLng, offsetLat]
  }

  clear () {
    this._lnglatMap = {}
    this._offsetTarget = null
  }

  _generateKey (lng, lat): string {
    return `${lng}:${lat}`
  }

  _has (key): boolean {
    return this._lnglatMap[key] !== undefined
  }

  _add (key): void {
    this._lnglatMap[key] = true
  }

  _randomShift (lng, lat): LnglatArray {
    this._offsetTarget = this._getRandomInt(2) === 0 ? 'lat' : 'lng'
    let offsetLng = lng
    let offsetLat = lat
    const operator = this._getShiftOperator(lng, lat)
    if (this._offsetTarget === 'lat') {
      if (operator === 'plus') {
        offsetLat += this._offset
      } else {
        offsetLat -= this._offset
      }
    } else {
      if (operator === 'plus') {
        offsetLng += this._offset
      } else {
        offsetLng -= this._offset
      }
    }
    offsetLng = clamp(offsetLng, -180, 180)
    offsetLat = clamp(offsetLat, -90, 90)
    return [offsetLng, offsetLat]
  }

  _getShiftOperator (lng, lat): 'minus' | 'plus' {
    if (this._offsetTarget === 'lat' && lat === -90) {
      return 'plus'
    }
    if (this._offsetTarget === 'lat' && lat === 90) {
      return 'minus'
    }
    if (this._offsetTarget === 'lng' && lng === -180) {
      return 'plus'
    }
    if (this._offsetTarget === 'lng' && lng === 180) {
      return 'minus'
    }
    return this._getRandomInt(2) === 0 ? 'minus' : 'plus'
  }

  _getRandomInt (max): number {
    return Math.floor(Math.random() * Math.floor(max))
  }
}
